import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Attach the active UI language so the backend can return localized content.
api.interceptors.request.use((config) => {
  try {
    const lang = window.localStorage.getItem("smarti_lang") || "fr";
    if (lang && lang !== "fr") {
      config.params = { ...(config.params || {}), lang };
    }
  } catch (_) {
    /* localStorage indisponible (mode privé / SSR) — on retombe sur la langue par défaut */
  }
  return config;
});

export function apiError(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const eur = (n) =>
  new Intl.NumberFormat("fr-BE", { style: "currency", currency: "EUR" }).format(n || 0);

export default api;
